// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__HIZ8X"};